"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snapshot2List = exports.updateNode = exports.removeNode = exports.queryNode = exports.listenNodeByKey = exports.getNode = exports.offNode = exports.onNode = exports.setNode = void 0;
var FirebaseApp_1 = require("./FirebaseApp");
var setNode = function (path, value) {
    if (!path || path.trim() === '') {
        return Promise.reject('path is empty!');
    }
    Object.keys(value).forEach(function (key) {
        if (value[key] === undefined) {
            delete value[key];
        }
    });
    try {
        return FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(path).set(value);
    }
    catch (err) {
        return Promise.reject(err);
    }
};
exports.setNode = setNode;
var onNode = function (path, onUpdateCallback, onErrorCallback) {
    if (!path || path.trim() === '') {
        return;
    }
    FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(path).on('value', onUpdateCallback, onErrorCallback);
};
exports.onNode = onNode;
var offNode = function (path) {
    if (!path || path.trim().length === 0) {
        return;
    }
    FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(path).off('value');
};
exports.offNode = offNode;
var getNode = function (path) {
    if (!path || path.trim() === '') {
        return Promise.reject('path is empty!');
    }
    try {
        return FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref(path)
            .orderByKey()
            .once('value', function (snapshot) { return Promise.resolve(snapshot); }, function (obj) { return Promise.reject(obj); });
    }
    catch (err) {
        return Promise.reject(err);
    }
};
exports.getNode = getNode;
var listenNodeByKey = function (path, childKey, value, callback) {
    if (!path || path.trim() === '') {
        return;
    }
    if (!childKey || childKey.trim() === '') {
        return;
    }
    if (!value) {
        return;
    }
    if (!callback) {
        return;
    }
    FirebaseApp_1.FirebaseApp.GET()
        .firebase.database()
        .ref(path)
        .orderByChild(childKey)
        .equalTo(value)
        .on('value', function (snapshot) { return callback.onUpdated(snapshot); }, function (obj) { return callback.onError(obj); });
};
exports.listenNodeByKey = listenNodeByKey;
var queryNode = function (path, childKey, value) {
    if (!path || path.trim() === '') {
        return Promise.reject('path is empty!');
    }
    return FirebaseApp_1.FirebaseApp.GET()
        .firebase.database()
        .ref(path)
        .orderByChild(childKey)
        .equalTo(value)
        .once('value', function (snapshot) { return Promise.resolve(snapshot); }, function (obj) { return Promise.reject(obj); });
};
exports.queryNode = queryNode;
var removeNode = function (path) {
    if (!path || path.trim() === '') {
        return Promise.reject('path is empty!');
    }
    return FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(path).remove();
};
exports.removeNode = removeNode;
var updateNode = function (path, value) {
    if (!path || path.trim() === '') {
        return Promise.reject('path is empty!');
    }
    Object.keys(value).forEach(function (key) {
        if (value[key] === undefined) {
            delete value[key];
        }
    });
    return FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(path).update(value);
};
exports.updateNode = updateNode;
var snapshot2List = function (snapshot) {
    if (!snapshot) {
        return [];
    }
    var list = [];
    snapshot.forEach(function (child) {
        list.push(child.val());
    });
    return list;
};
exports.snapshot2List = snapshot2List;
//# sourceMappingURL=FirebaseUtils.js.map